import React from 'react'
import Avatar from 'components/Avatar'
import ApartmentIcon from 'components/icons/ApartmentIcon'
import CustomTag from 'components/CustomTag'
import { COLORS } from 'theme'
import {
  SubFLex,
  SecondaryHeading,
  GreyText,
  StyledP,
  EditorContent,
  VerticalDivider,
  NameAdd1,
  TextLight1,
  BoldTextDate,
  RewardTite
} from 'modules/Resume/Style/style'
import Flex from 'components/Flex'
import moment from 'moment'
import FileReaderVisibleOnly from 'components/Uploader/FileReaderVisibleOnly'
import AwardsIconWork from 'components/icons/AwardsIconWork'
import { ExclamationCircleFilled } from '@ant-design/icons'
import styled from 'styled-components'

const PendingIcon = styled(ExclamationCircleFilled)`
  color: #eb5d60;
  font-size: 16px;
  margin-left: 8px;
`

const InternshipSection = ({ studentDetails, pendingData }) => {

  const hasFieldPending = (item, fieldName) => {
    return item?._pendingFields && item._pendingFields[fieldName] !== undefined
  }

  const approvedInternships = studentDetails?.resume?.internships || []
  const pendingInternships = pendingData?.resume?.internships || []
  
  const allInternships = approvedInternships.map(approved => {
    const pendingChange = pendingInternships.find(
      pending => pending.id === approved.id || pending._itemId === approved.id
    )
    
    if (pendingChange && pendingChange._pendingFields) {
      const merged = {
        ...approved,
        ...pendingChange,
        _requestId: Object.values(pendingChange._pendingFields)[0]?._requestId,
        _status: Object.values(pendingChange._pendingFields)[0]?._status
      }
      
      // Map companyName to organization for display
      if (pendingChange.companyName) {
        merged.organization = pendingChange.companyName
      }
      
      // Update _pendingFields to include organization if companyName is pending
      if (pendingChange._pendingFields.companyName) {
        merged._pendingFields = {
          ...merged._pendingFields,
          organization: pendingChange._pendingFields.companyName
        }
      }
      
      return merged
    }
    
    return approved
  })
  
  const newPendingInternships = pendingInternships.filter(
    pending => pending._isNew || !approvedInternships.find(approved => approved.id === pending.id || approved.id === pending._itemId)
  )
  
  allInternships.push(...newPendingInternships)

  const DateDiff = (start, end) => {
    if (!start) return '';
    
    const StartSplit = start?.split('/')
    if (!StartSplit || StartSplit.length < 2) return '';
    
    const EndSplit = end ? end?.split('/') : null
    const startDate = new Date(StartSplit[1], StartSplit[0], 1)
    const endDate = end && EndSplit && EndSplit.length >= 2 ? new Date(EndSplit[1], EndSplit[0], 1) : new Date()
    const diffInMonths =
      (endDate.getFullYear() - startDate.getFullYear()) * 12 +
      (endDate.getMonth() - startDate.getMonth()) + 1

    if (diffInMonths >= 12) {
      const years = Math.floor(diffInMonths / 12)
      const months = diffInMonths % 12
      return `(${years === 1 ?   years + ' year' : years > 1 ? years + ' years' : '' } ${months === 1 ?   months + ' month' : months > 1 ? months + ' months' : '' })`;
    } else {
        return `(${diffInMonths === 1 ?   diffInMonths + ' month' : diffInMonths > 1 ? diffInMonths + ' months' : '' })`;
      }

  }

  return (
    
      <SubFLex column gap="25px">
        {allInternships.map((item, index) => (
          <SubFLex gap="12px" key={index+"internship"}>
            <div>
              <Avatar
                background="none"
                src={''}
                size={48}
                icon={<ApartmentIcon />}
                boxShadow={true}
                padding="5px"
              />
            </div>
            <SubFLex column style={{width:'90%'}}>
              <Flex centerVertically spaceBetween wrap>
                <SecondaryHeading style={{ wordBreak: 'break-word', overflowWrap: 'anywhere', display: 'flex', alignItems: 'center', margin: '0 1% 1% 0' }}>
                  <span>{item?.organization}</span>
                  {/* {hasFieldPending(item, 'organization') && <PendingIcon />} */}
                </SecondaryHeading>
                {(item?._pendingFields || item?._requestId) && (
                  <CustomTag
                    message={item?.id ? "Verification Pending" : "Verification Pending"}
                    bordered={true}
                    background={'#eb5d60'}
                    border={'#eb5d60'}
                    color={'#fff'}
                  />
                )}
              </Flex>
              {(item?.started_in || item?.ended_in) && (
                <GreyText color={COLORS.GREY_T_60} style={{ display: 'flex', alignItems: 'center' }}>
                  <span>
                    {moment(item?.started_in,'MM/YYYY')?.format('MMM YYYY')} -{' '}
                    {moment(item?.ended_in,'MM/YYYY')?.format('MMM YYYY')} {DateDiff(item?.started_in, item?.ended_in)}
                  </span>
                  {/* {(hasFieldPending(item, 'started_in') || hasFieldPending(item, 'ended_in')) && <PendingIcon />} */}
                </GreyText>
              )}
                {item?.skill_set?.length > 0 &&
                <SecondaryHeading fontWeight="600">
                  Skills
                </SecondaryHeading>
                }
              <SubFLex centerVertically gap="5px" marginBottom="15px" wrap>
                {item?.skill_set?.map((value, key) => (
                  <CustomTag
                    message={value?.name}
                    bordered={true}
                    key={key+"skill"}
                    background={'#F2F3F5'}
                    border={'#F2F3F5'}
                  />
                ))}
              </SubFLex>
             <Flex centerVertically>
  {/* {item.function &&
    <>
      <NameAdd1 column flexStart>
        <TextLight1 color={COLORS.GREY_T_20}>Function</TextLight1>
        <BoldTextDate color={COLORS.GREY_T_20} style={{ wordBreak: 'break-word', overflowWrap: 'anywhere', display: 'flex', alignItems: 'center' }}>
          <span>{item.function}</span>
          
        </BoldTextDate>
      </NameAdd1>
      {item.role && <VerticalDivider type="vertical" />}
    </>
  } */}
  {item.role &&
    <>
      <NameAdd1 column flexStart>
        <TextLight1 color={COLORS.GREY_T_20}>Role</TextLight1>
        <BoldTextDate color={COLORS.GREY_T_20} style={{ wordBreak: 'break-word', overflowWrap: 'anywhere', display: 'flex', alignItems: 'center' }}>
          <span>{item.role}</span>
          {/* {hasFieldPending(item, 'role') && <PendingIcon />} */}
        </BoldTextDate>
      </NameAdd1>
      {item.industry && <VerticalDivider type="vertical" />}
    </>
  }
  {item.industry &&
      <NameAdd1 column flexStart>
        <TextLight1 color={COLORS.GREY_T_20}>Industry</TextLight1>
        <BoldTextDate color={COLORS.GREY_T_20} style={{ wordBreak: 'break-word', overflowWrap: 'anywhere', display: 'flex', alignItems: 'center' }}>
          <span>{item.industry}</span>
         
        </BoldTextDate>
      </NameAdd1>
  }
</Flex> 


              <StyledP style={{ display: 'flex', alignItems: 'flex-start' }}>
                <EditorContent
                  dangerouslySetInnerHTML={{
                    __html: item?.description || '',
                  }}
                />
                
              </StyledP>
              {/* {item?.certificate   &&
              <FileReaderVisibleOnly file={item?.certificate} />
              } */}

              {item?.certificate && Object.keys(item?.certificate).length > 0 && (
                                        <>
                                          {hasFieldPending(item, 'certificate') ? (
                                            <div
                                              style={{
                                                background: '#FFE5E6',
                                                padding: '12px 16px',
                                                borderRadius: '8px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                marginTop: '8px',
                                                marginBottom: '8px'
                                              }}
                                            >
                                              <span style={{ fontSize: '14px', color: '#1F2937' }}>
                                                Marksheet Submitted - <span style={{ color: '#3249D7', fontWeight: 500 }}>{item?.certificate?.name || 'Document.jpg'}</span>
                                              </span>
                                              <button
                                                onClick={() => {
                                                  const newWindow = window.open(item?.certificate?.url, '_blank', 'noopener,noreferrer')
                                                  if (newWindow) newWindow.opener = null
                                                }}
                                                style={{
                                                  background: '#3249D7',
                                                  color: '#fff',
                                                  border: 'none',
                                                  borderRadius: '6px',
                                                  padding: '6px 20px',
                                                  fontSize: '14px',
                                                  fontWeight: 500,
                                                  cursor: 'pointer'
                                                }}
                                              >
                                                View
                                              </button>
                                            </div>
                                          ) : (
                                            <FileReaderVisibleOnly file={item?.certificate} />
                                          )}
                                        </>
                                      )}
               {item?.awards?.length > 0 &&  studentDetails?.student?.isExpCandidate &&(
                  <RewardTite>Rewards and Recognition </RewardTite>
                )}
                {item?.awards?.map((value, key) => (
                  
                    <SubFLex column gap="25px" marginBottom="10px" key={key+"awards"}>
                      <SubFLex gap="12px">
                        <div>
                          <Avatar
                            background="none"
                            src={''}
                            size={48}
                            icon={<AwardsIconWork />}
                            boxShadow={true}
                            padding="5px"
                          />
                        </div>
                        <SubFLex column style={{width:'90%'}}>
                          <SecondaryHeading>{value?.title}</SecondaryHeading>

                          <GreyText color={COLORS.GREY_T_60}>
                            {moment(value?.awarded_on).format('DD MMM YYYY')}
                          </GreyText>

                          <StyledP>
                            {' '}
                            <EditorContent
                              dangerouslySetInnerHTML={{
                                __html: value?.description || '',
                              }}
                            />{' '}
                          </StyledP>
                          {value?.certificate && (
                            <FileReaderVisibleOnly file={value?.certificate} />
                          )}
                        </SubFLex>
                      </SubFLex>
                    </SubFLex>
                  
                ))}
            </SubFLex>
          </SubFLex>
        ))}
      </SubFLex>
    
  )
}

export default InternshipSection
